import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-container mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.dsAgenti,
        "key-expr": "ID",
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnAutoWidth: false,
        columnMinWidth: 50,
        columnResizingMode: 'nextColumn',
        "show-borders": true,
        "filter-sync-enabled": true,
        "show-row-lines": true,
        "show-column-lines": false,
        "on-row-updated": _ctx.onRowUpdatedAgenti,
        "on-editor-preparing": _ctx.onEditor,
        ref: "dataGridRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxEditing, {
            mode: "cell",
            "allow-updating": true
          }),
          _createVNode(_component_DxPaging, {
            "page-size": 8,
            "page-index": 0
          }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserID",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Nume",
            allowEditing: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "HasRight",
            "data-type": "boolean",
            caption: "Are drept?",
            allowEditing: true,
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Citeste",
            "data-type": "boolean",
            allowEditing: true,
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Modifica",
            "data-type": "boolean",
            allowEditing: true,
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Sterge",
            "data-type": "boolean",
            allowEditing: true,
            "allow-filtering": false
          })
        ]),
        _: 1
      }, 8, ["data-source", "on-row-updated", "on-editor-preparing"])
    ]),
    _createVNode(_component_DxPopupAdd, { visible: _ctx.isModalVisible }, null, 8, ["visible"])
  ], 64))
}